<template>

    <div class="scorecard">
        <div class="name">{{ player.name }}</div>
        <div class="score">{{ player.score }}</div>
        <div class="target">{{ target }}</div>
        <div class="legs"><span>Legs: </span>{{ player.legs }}</div>
    </div>

</template>

<script>

export default {

    name: 'Scorecard',

    data() {
        return {
            singles: [],
            doubles: [],
            triples: []
        }
    },

    computed: {
        target() {
            // Assume player can finish this turn. Turn back to false when they can't.
            this.player.canFinish = true;

            // Finish with 1 dart
            for (let dart1 = this.doubles.length - 1; dart1 >= 0; dart1--) {
                if (this.player.score == this.doubles[dart1]) {
                    let target1 = "D" + this.doubles[dart1] / 2;
                    if (this.doubles[dart1] == 50) {
                        target1 = "BULL";
                    }
                    return target1
                }
            }

            // Finish with 2 darts
            for (let dart2 = this.doubles.length - 1; dart2 >= 0; dart2--) {
                // Finish with 2 darts, filler is a single
                for (let dart1 = 0; dart1 < this.singles.length; dart1++) {
                    if (this.player.score == this.doubles[dart2] + this.singles[dart1]) {
                        let target1 = this.singles[dart1];
                        let target2 = "D" + this.doubles[dart2] / 2;
                        if (this.doubles[dart2] == 50) {
                            target2 = "BULL";
                        }
                        return target1 + "  " + target2;
                    }
                }
                // Finish with 2 darts, filler is a triple
                for (let dart1 = 0; dart1 < this.triples.length; dart1++) {
                    if (this.player.score == this.doubles[dart2] + this.triples[dart1]) {
                        let target1 = "T" + this.triples[dart1] / 3
                        let target2 = "D" + this.doubles[dart2] / 2;
                        if (this.doubles[dart2] == 50) {
                            target2 = "BULL";
                        }
                        return target1 + "  " + target2;
                    }
                }
            }

            // Finish with 3 darts, fillers are a triple and a single
            for (let dart3 = this.doubles.length - 1; dart3 >= 0; dart3--) {
                for (let dart2 = this.triples.length - 1; dart2 >= 0; dart2--) {
                    for (let dart1 = this.singles.length - 1; dart1 >= 0; dart1--) {
                        if (this.player.score == this.doubles[dart3] + this.triples[dart2] + this.singles[dart1]) {
                            let target1 = "T" + this.triples[dart2] / 3;
                            let target2 = this.singles[dart1];
                            let target3 = "D" + this.doubles[dart3] / 2;
                            if (this.doubles[dart3] == 50) {
                                target3 = "BULL";
                            }
                            return target1 + "  " + target2 + "  " + target3;
                        }
                    }
                }
            }

            // Finish with 3 darts, fillers are 2 triples
            for (let dart3 = this.doubles.length - 1; dart3 >= 0; dart3--) {
                for (let dart2 = this.triples.length - 1; dart2 >= 0; dart2--) {
                    for (let dart1 = this.triples.length - 1; dart1 >= 0; dart1--) {
                        if (this.player.score == this.doubles[dart3] + this.triples[dart2] + this.triples[dart1]) {
                            let target1 = "T" + this.triples[dart1] / 3;
                            let target2 = "T" + this.triples[dart2] / 3;
                            let target3 = "D" + this.doubles[dart3] / 2;
                            // Switch first and second dart if second is higher                            
                            if (this.triples[dart2] > this.triples[dart1]) {
                                target1 = "T" + this.triples[dart2] / 3;
                                target2 = "T" + this.triples[dart1] / 3;
                            }
                            if (this.doubles[dart3] == 50) {
                                target3 = "BULL";
                            }
                            return  target1 + "  " + target2 + "  " + target3;
                        }
                    }
                }
            }

            // Can't finish with this score
            this.player.canFinish = false;
            return "-  -  -";
        }
    },

    props: {
        player: Object
    },

    methods: {
        
    },

    mounted() {
        this.doubles.push(50);
        for (let i = 1; i <= 20; i++) {
            this.singles.push(i);
            // this.doubles.push(i * 2);
            this.triples.push(i * 3);
        }
        // Custom prefered doubles list. From least prefered (top) to most prefered (bottom).
        this.doubles.push(2 * 25);

        this.doubles.push(2 * 1);
        this.doubles.push(2 * 3);
        this.doubles.push(2 * 5);
        this.doubles.push(2 * 7);
        this.doubles.push(2 * 9);

        this.doubles.push(2 * 11);
        this.doubles.push(2 * 13);
        this.doubles.push(2 * 15);
        this.doubles.push(2 * 17);
        this.doubles.push(2 * 19);

        this.doubles.push(2 * 2);
        this.doubles.push(2 * 6);
        this.doubles.push(2 * 10);
        this.doubles.push(2 * 14);
        this.doubles.push(2 * 18);

        this.doubles.push(2 * 4);
        this.doubles.push(2 * 8);
        this.doubles.push(2 * 12);
        this.doubles.push(2 * 16);
        this.doubles.push(2 * 20);
    }
}
</script>


<style scoped>

    .scorecard {
        width: 225px;
        height: 196px;
        /*border: 2px solid #aaa;*/
        margin-right: 10px;
        margin-bottom: 10px;
        
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.24), 0 1px 2px rgba(0,0,0,0.48);
        display: flex;
        /*justify-content: center;*/
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        border: 3px solid #ccc;
        box-sizing: border-box;
        
    }

    .scorecard.currentPlayer {
        border: 3px solid yellowgreen;
        
    }
    .scorecard.currentPlayer .target {
        border: 1px solid yellowgreen;
        background: greenyellow;
    }



    .scorecard .name {
        font-size: 32px;
        line-height: 40px;
        /*font-weight: bold;*/
    }

    .scorecard .score {
        font-size: 60px;
        line-height: 60px;
        margin-bottom: 8px;
    }

    .scorecard .target {
        font-size: 30px;
        line-height: 44px;
        white-space: pre;
        width: 100%;
        background: #eee;
        border: 1px solid #ccc;
    }

    .scorecard .legs {
        font-size: 20px;
        line-height: 34px;
    }



</style>
